export default __webpack_public_path__ + "static/media/haladiem.da2b613c.png";